import React from 'react'
import { useSelector } from 'react-redux'
import {
  getFacilities,
  getFacilitiesError,
  getFacilitiesLoading,
} from '../../pages/slices/facility.slice'
import { Box, Grid, Skeleton, Typography } from '@mui/material'
import CopyToClipboard from '../common/CopyToClipboard/CopyToClipboard'

export default function FacilityName({ facilityId }) {
  const isFacilitiesLoading = useSelector(getFacilitiesLoading)
  const isFacilitiesError = useSelector(getFacilitiesError)
  const facilities = useSelector(getFacilities)
  // Find facility details based on kpro_team_id
  const facility = facilities?.find(
    (facility) => facility?.kpro_team_id === facilityId
  )
  const facilityName = facility?.facility_name || 'N/A'
  const facilityTeamId = facility?.kpro_team_id || 'N/A'

  const facilityDisplayName = isFacilitiesError ? (
        <Typography variant="body1" color="error">
          Error fetching team: {isFacilitiesError?.message || 'Unknown error'}
        </Typography>
      ) : (
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body1">{facilityName}</Typography>
          {facilityName && facilityName !== 'N/A' ? (
            <CopyToClipboard
              menuOptions={[
                {
                  label: 'Copy Facility Name',
                  value: facilityName,
                },
                {
                  label: 'Copy Facility ID',
                  value: facilityTeamId,
                },
              ]}
            />
          ) : null}
        </Box>
      )

  return (
    <Grid item xs={4}>
      <Typography variant="subtitle2" color="textSecondary">
        Facility Name
      </Typography>
        {isFacilitiesLoading ? <Skeleton variant="text" width={250} /> : facilityDisplayName}
    </Grid>
  )
}
